// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3LFm1","balanceDisclaimer":"posDashboard_balanceDisclaimer__2SrZW"};